export const dashboard = '/telekardia/dashboard';
export const appointments = '/telekardia/appointments';
export const all_appointments = '/telekardia/all-appointments';
export const admin_dashboard = '/admin/dashboard';
export const admin_feedbacks = '/admin/feedbacks';
